const valueTypesOnlyApplicableToNorthernHemisphere = [
  'chillCumulativeHoursBelow45FNOV',
  'chillCumulativeHoursBelow45FSEP',
  'chillCumulativeHoursBetween32and45FNOV',
  'chillCumulativeHoursBetween32and45FSEP',
  'chillCumulativePortionsNOV',
  'chillCumulativePortionsSEP',
]

const valueTypesOnlyApplicableToSouthernHemisphere = [
  'chillCumulativeHoursBelow45FMAR',
  'chillCumulativeHoursBelow45FMAY',
  'chillCumulativeHoursBetween32and45FMAR',
  'chillCumulativeHoursBetween32and45FMAY',
  'chillCumulativePortionsMAR',
  'chillCumulativePortionsMAY',
]

type TApplicableHemisphere = 'NORTHERN_HEMISPHERE' | 'SOUTHERN_HEMISPHERE' | 'BOTH_HEMISPHERES'

export const getValueTypeHemisphere = (valueType: string): TApplicableHemisphere => {
  if (valueTypesOnlyApplicableToNorthernHemisphere.includes(valueType)) {
    return 'NORTHERN_HEMISPHERE'
  }

  if (valueTypesOnlyApplicableToSouthernHemisphere.includes(valueType)) {
    return 'SOUTHERN_HEMISPHERE'
  }

  return 'BOTH_HEMISPHERES'
}
